import React, { useState } from 'react';

import { IconChevronDown } from '@tabler/icons-react';

type AccordionProps = {
  children: React.ReactNode;
  label: React.ReactNode;
  initialIsOpen?: boolean;
  hasBorder?: boolean;
  showIcon?: boolean;
  labelClasses?: string;
  containerClasses?: string;
};
export const Accordion = ({
  children,
  label,
  initialIsOpen,
  hasBorder = true,
  showIcon = true,
  labelClasses = '',
  containerClasses = '',
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen || false);

  const borderClass = hasBorder ? `rounded-[8px] border border-gray-900 p-3` : '';
  const containerClass = `w-full ${borderClass}`;

  return (
    <div className={containerClass}>
      <div className={`w-full ${hasBorder ? '' : 'p-2'}  ${containerClasses}`}>
        <div
          className={`flex w-full items-center justify-between text-[14px] text-slate-400 ${labelClasses}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <>{label}</>
          {showIcon ? (
            <span className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}>
              <IconChevronDown size={16} />
            </span>
          ) : null}
        </div>
        {isOpen && children}
      </div>
    </div>
  );
};
